<app-dialog
  [headerText]="title"
  saveText="Move"
  [showTopCancelButton]="false"
  [body]="body"
  (save)="onMoveResource()"
  [validationFn]="validate.bind(this)"
></app-dialog>
<ng-template #body>
  @if (!loading) {
    <form [formGroup]="form" autocomplete="off">
      <div class="move-resource-info-text" [textContent]="infoText"></div>
      <div class="details-row">
        <label fd-form-label>Name:</label>
        <span class="details-value">{{ resourceDisplayName }}</span>
      </div>
      <div class="details-row">
        <label fd-form-label>Current Path:</label>
        <span class="details-value">{{ currentPath }}</span>
      </div>
      <div class="target-location-title">
        <h3 class="section-title" title="Target Location">Target Location</h3>
        <span>
          <app-help-popover
            [body]="targetLocationPopoverBody"
            headerTitle="Target Location"
            width="35rem"
            [placement]="'bottom'"
          ></app-help-popover>
        </span>
      </div>
      <app-container [body]="targetLocationTmpl"></app-container>
      <ng-template #targetLocationTmpl>
        <fd-form-input-message-group class="move-container-form">
          <app-helpful-label
            [required]="true"
            for="move-resource-destination-path-input"
            i18n-label="
              XFLD|Label of the Path input@@move.resource.path.input.label"
            label="Path"
          >
          </app-helpful-label>
          <input
            fd-form-control
            id="move-resource-destination-path-input"
            name="path"
            formControlName="path"
            type="text"
            [placeholder]="destinationPathPlaceholder"
            [state]="Utils.getValidationState(form.get('path'))"
          />
          @if (
            (form.get("path")!.touched || form.get("path")!.dirty) &&
            form.get("path")!.getError("required")
          ) {
            <fd-form-message tabindex="-1" [type]="'error'">
              Path is required
            </fd-form-message>
          }
          @if (
            (form.get("path")!.touched || form.get("path")!.dirty) &&
            form.get("path")!.getError("invalidPath")
          ) {
            <fd-form-message [type]="'error'">
              Path can contain only lowercase alphabetical letters (a-z),
              numbers (0-9), hyphens (-), periods (.), and forward slashes (/).
              Must start with a forward slash, and end with a lowercase letter
              or number.
            </fd-form-message>
          }
        </fd-form-input-message-group>
        <fd-form-input-message-group [triggers]="['mouseenter', 'mouseleave']">
          <app-helpful-label
            [required]="true"
            for="move-resource-destination-resource-name-input"
            i18n-label="
              XFLD|Label of the Technical Name
              input@@move.resource.name.input.label"
            label="Technical Name"
          >
          </app-helpful-label>
          <input
            fd-form-control
            fdCompact
            id="move-resource-destination-resource-name-input"
            name="name"
            formControlName="name"
            type="text"
            [placeholder]="destinationNamePlaceholder"
            [state]="Utils.getValidationState(form.get('name'))"
          />
          @if (
            (form.get("name")!.touched || form.get("name")!.dirty) &&
            form.get("name")!.getError("required")
          ) {
            <fd-form-message tabindex="-1" [type]="'error'">
              Technical Name is required
            </fd-form-message>
          }
          @if (
            (form.get("name")!.touched || form.get("name")!.dirty) &&
            form.get("name")!.getError("invalidName")
          ) {
            <fd-form-message [type]="'error'">
              Technical name can contain only lowercase alphabetical letters
              (a-z), numbers (0-9), hyphens (-), and periods (.). Must start and
              end with a lowercase letter or number.
            </fd-form-message>
          }
          @if (
            (form.get("name")!.touched || form.get("name")!.dirty) &&
            form.get("name")!.getError("maxlength")
          ) {
            <fd-form-message [type]="'error'">
              Technical name must not be longer than 63 characters.
            </fd-form-message>
          }
        </fd-form-input-message-group>
      </ng-template>
      <ng-template #targetLocationPopoverBody>
        Specify the location where you want to move the selected folder and its
        contents by entering its technical name (for example: my-resource-group)
        and its path (example: \my-org\my-folder).
        <br /><br />
        NOTE:
        <ul>
          <li>
            You must have full admin permission on the target location.<br /><br />
          </li>
          <li>
            The type of container you choose depends on the resource type that
            you are moving.<br /><br />
            For example, folders and resource groups can be moved only to
            folders, while most other resource types can be moved either to a
            folder or a resource group.<br /><br />
            Services and resources that share the same lifecycle or that have a
            close relationship and interdependency between them should be
            managed in the same resource group.<br /><br />
          </li>
          <li>
            Folders and resource groups are moved together with their content.
          </li>
        </ul>
      </ng-template>
    </form>
  }
</ng-template>
